module.exports = __webpack_public_path__ + "media/images/app/colors/colors-pink-c526af52a5689c173ab1c45041dff9ca.webp";